module.exports = __webpack_public_path__ + "static/media/interlock.634de56c.svg";